<template>
    <div>
      <div class="modal fade" id="advanceSecurityRecord">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              >
              <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Advance Security</h4>
            </div>
            <form @submit.prevent="advanceSecurityCollect()">
              <div class="modal-body">
              <!-- right column -->
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                      <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                            <label>Payment Type <span class="red">*</span></label>
                            <select
                                v-model="form.type"
                                name="type"
                                class="form-control"
                                :class="{
                                'is-invalid': form.errors.has('type'),
                                }"
                                required
                            >
                                <option v-if="!form.type" selected value="">
                                Select Type
                                </option>
                                <option v-if="advanceSecurityRecord.planCategory === 'interest'" value="principal">Principal</option>
                                <option v-if="advanceSecurityRecord.planCategory === 'interest'" value="interest">Interest</option>
                                <option v-if="advanceSecurityRecord.planCategory !== 'interest'" value="emi">Emi</option>
                            </select>
                            <has-error :form="form" field="type"></has-error>
                        </div>
                        <div class="form-group">
                          <label>Select Ledger Account </label>
                          <select
                              v-model="form.branch_ledger_id"
                              name="branch_ledger_id"
                              class="form-control"
                              :class="{
                              'is-invalid': form.errors.has('branch_ledger_id'),
                              }"
                          >
                              <option v-if="!form.branch_ledger_id" selected value="">
                              Select Ledger Account
                              </option>
                              <option
                              :value="bank_account.id"
                              v-for="bank_account in payment_ledgers"
                              :key="bank_account.id"
                              >
                              {{bank_account.name}} {{bank_account.remark}}
                              </option>
                          </select>
                          <has-error :form="form" field="branch_ledger_id"></has-error>
                        </div>
                        <div class="form-group">
                          <label> No of Advance Installment</label>
                          <input
                            v-model="form.advanceInstallment"
                            type="number"
                            name="advanceInstallment"
                            placeholder="Please Enter advanceInstallment"
                            class="form-control"
                            :class="{
                            'is-invalid': form.errors.has(
                                'advanceInstallment'
                            ),
                            }"
                          />
                          <has-error
                            :form="form"
                            field="advanceInstallment"
                          ></has-error>
                        </div>
                    </div>
                    
                    <div class="col-sm-6">
                        <div class="form-group">
                          <label>
                              Payment Date
                              <span class="red">*</span></label
                          >
                          <input
                              v-model="form.paymentDate"
                              type="date"
                              name="paymentDate"
                              class="form-control"
                              :class="{
                              'is-invalid': form.errors.has(
                                  'paymentDate'
                              ),
                              }"
                              placeholder="Enter Payment Date"
                              required
                          />
                          <has-error
                              :form="form"
                              field="paymentDate"
                          ></has-error>
                        </div>
                      
                          <div class="form-group">
                            <label> Amount</label>
                            <input
                              v-model="form.amt"
                              type="text"
                              name="amt"
                              placeholder="Please Enter amt"
                              class="form-control"
                              :class="{
                              'is-invalid': form.errors.has(
                                  'amt'
                              ),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="amt"
                            ></has-error>
                          </div>
                          
                      </div>
                      </div>
                  </div>
                  <!-- /.card-body -->
                  </div>
              
              <!--/.col (right) -->
              </div>
              <div class="modal-footer text-center">
              <button type="submit" class="btn btn-success">
                  COLLECT
              </button>
  
              <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
              >
                  CANCEL
              </button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
      <!-- /.modal-dialog -->
      </div>
    </div>
  </template>
  <script>
  export default({
    name: 'AdvanceSecurity',
    data () {
      return {
        form: new Form({
          amt: '',
          branch_id: '',
          paymentDate: '',
          branch_ledger_id: '',
          member_loan_plan_id: '',
          member_id: '',
          disbursement_id: '',
          collection_center_id: '',
          advanceInstallment: '',
          type: ''
        })
      }
    },
    methods: {
      advanceSecurityCollect () {
        this.form.branch_id = this.advanceSecurityRecord.branch_id
        this.form.member_loan_plan_id = this.advanceSecurityRecord.member_loan_plan.id
        this.form.member_id = this.advanceSecurityRecord.member_id
        this.form.disbursement_id = this.advanceSecurityRecord.id
        this.form.collection_center_id = this.advanceSecurityRecord.collection_center_id
        this.$axios
        .post('advanceemisecurity', this.form, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#advanceSecurityRecord').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Record Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      }
    },
    props: {
      advanceSecurityRecord: {},
      payment_ledgers: {}
    }
  })
  </script>



// WEBPACK FOOTER //
// AdavanceSecurity.vue?4609b263